type KingProps = {
    className?: string;
};

export default function King({ className }: KingProps) {
    return (
        <svg
            className={className}
            viewBox="0 0 69 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M34.2509 18.608V9.59998M30.4453 12.8H38.0564"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.2495 40C34.2495 40 41.0995 28 38.8161 23.2C38.8161 23.2 37.2939 19.2 34.2495 19.2C31.205 19.2 29.6828 23.2 29.6828 23.2C27.3994 28 34.2495 40 34.2495 40Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.0282 59.2C27.4004 64.8 41.1004 64.8 49.4726 59.2V48C49.4726 48 63.1726 40.8 58.606 31.2C52.5171 20.8 38.056 25.6 34.2504 37.6C30.4449 25.6 15.9838 20.8 9.89486 31.2C5.3282 40.8 19.0282 48 19.0282 48V59.2Z"
                fill="currentColor"
            />
            <path
                d="M34.2504 37.6C38.056 25.6 52.5171 20.8 58.606 31.2C63.1726 40.8 49.4726 48 49.4726 48V59.2C41.1004 64.8 27.4004 64.8 19.0282 59.2V48C19.0282 48 5.3282 40.8 9.89486 31.2C15.9838 20.8 30.4449 25.6 34.2504 37.6ZM34.2504 37.6V43.2"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.0273 48C27.3996 43.2 41.0996 43.2 49.4718 48M19.0273 53.6C27.3996 48.8 41.0996 48.8 49.4718 53.6M19.0273 59.2C27.3996 54.4 41.0996 54.4 49.4718 59.2"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
